import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { resolvers } from './graphql/resolvers';
import { initializeLocalState } from './graphql/localState/initializeLocalState';

export const strapiUrl =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:1337';
export const mediaDir = strapiUrl;
export const apiUrl = strapiUrl + '/api';

export const imageDir = '/images/';

const httpLink = createHttpLink({
  uri: strapiUrl + '/graphql'
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const cache = new InMemoryCache();

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  resolvers
});

initializeLocalState(cache);

client.onResetStore(async () => initializeLocalState(cache));
export default client;
